import React, { Component } from "react"
import { withTranslation } from "react-i18next"
import BuyNewTireCard from "./NewTireCard"
import TechAdvisorCard from "./TechAdvisorCard"
import InviteFriends from "./InviteFriends"
import UnlockMaintenanceCard from "./UnlockMaintenanceCard"
import DiagnoseProblemCard from "./DiagnoseProblemCard"
import WarrantyPlanCard from "./WarrantyPlanCard"
import { nextMembershipUpgrades } from "../../../v1/helpers/membershipHelpers"
import { connect } from "react-redux"
import { getSubdomain } from "../../../v1/components/Config/StylesheetInjector"
import {
  GRUBHUB,
  INSTACART,
  INSTACART_CA,
  SHIPT,
  UBER,
  UBER_CANADA,
  USAA
} from "../../../v1/constants/affiliations"
import { isEmpty } from "lodash"
import { getPartnerFeatureFlag } from "../../../shared_component/utils/partnerFeatureFlag"
import { getSplitIOForFeatures } from "../../../v1/actions/user"
import { TIRE, VSC } from "../../../v1/constants/offers"
import AffilationCards from "./AffilationCards"
import DashBoardCards from "./DashboardCards"

class JustForYouCards extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tiresResponse: {},
      vscResponse: {},
      partnersOffersFlag: null
    }
  }

  async componentDidMount() {
    const { user, getSplitIOForFeatures } = this.props
    const responseTires = await getSplitIOForFeatures(TIRE)
    const responseVSC = await getSplitIOForFeatures(VSC)
    this.setState({
      vscResponse:
        responseVSC &&
        responseVSC.result &&
        Object.values(responseVSC.result).some((value) => value === true)
    })
    const result = await getPartnerFeatureFlag(user)
    this.setState({ tiresResponse: responseTires?.result?.tireconnect })
    if (result) {
      this.setState({
        partnersOffersFlag: result
      })
    }
  }

  render() {
    const subDomain = getSubdomain()
    const { tiresResponse, partnersOffersFlag, vscResponse } = this.state
    const { activeVehicle, isCart, t, cart, user } = this.props
    const { affiliation } = user
    const initialCards = [<TechAdvisorCard />, <InviteFriends />]
    if (partnersOffersFlag && vscResponse) {
      initialCards.push(<WarrantyPlanCard />)
    }

    let cards = [...initialCards]

    if (isEmpty(activeVehicle)) {
      cards = [<UnlockMaintenanceCard />, <TechAdvisorCard />]
      const validSubdomains = [UBER, UBER_CANADA, INSTACART, INSTACART_CA, SHIPT, USAA, GRUBHUB]
      if (
        validSubdomains.includes(subDomain) &&
        affiliation &&
        affiliation.displays_affiliation_to_customer
      ) {
        cards.splice(0, 0, <AffilationCards />)
      }
    } else {
      if (isCart) {
        cards = [<UnlockMaintenanceCard />, ...cards]
      } else {
        cards = [<UnlockMaintenanceCard />, ...cards]
      }
      // if (
      //   (user.membership &&
      //     user.membership.plan_name &&
      //     user.membership.plan_name == "Basic" &&
      //     subDomain === UBER) ||
      //   (cart && cart.order_services.length !== 0 && subDomain === UBER) ||
      //   (cart &&
      //     cart.order_services.length !== 0 &&
      //     user.membership &&
      //     user.membership.plan_name &&
      //     user.membership.plan_name == "Basic")
      // ) {
      //   cards = [<DiagnoseProblemCard />, ...cards]
      // }
      if (subDomain === UBER || subDomain === UBER_CANADA) {
        if (
          partnersOffersFlag &&
          tiresResponse &&
          tiresResponse &&
          cart &&
          cart.order_services.length !== 0 &&
          user &&
          user.membership &&
          user.membership.plan_name == "Basic"
        ) {
          cards.splice(0, 0, <BuyNewTireCard />)
        }
      }
    }
    return (
      <div className="dashboard-just-for-you-container">
        <p className="just-for-you-section-header">{t("justForYouLbl")}</p>
        <div className="dashboard-just-for-you-card-section">
          {cards && cards.map((card, index) => <React.Fragment key={index}>{card}</React.Fragment>)}
          {!isEmpty(activeVehicle) && <DashBoardCards />}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let { membershipData } = state
  let cart
  let isCart
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  if (currentActiveOrder) {
    cart = currentActiveOrder
    isCart = false
  } else {
    isCart = true

    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }

  return {
    isCart: isCart,
    cart: cart,
    user: user,
    activeVehicle,
    orderLoading: state.orders.loading,
    nextUpgrades: nextMembershipUpgrades(user, membershipData.availableMembershipPlans)
  }
}

export default connect(mapStateToProps, { getSplitIOForFeatures })(
  withTranslation("justForYouCards")(JustForYouCards)
)
